import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    chaveGD: '',
    chaveCI: ''
}

const mapaSlice = createSlice({
    name: 'mapa',
    initialState,
    reducers: {
        setChaveGD: (state, action) => {
            state.chaveGD = action.payload;
        },
        setChaveCI: (state, action) => {
            state.chaveCI = action.payload;
        }
    }
});

export const { setChaveGD, setChaveCI } = mapaSlice.actions;
export default mapaSlice.reducer;